import React, { useState } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { DrawerHeader } from '@features/Modal';
import { AssignPositionForm } from './components';
import { IServicePositionLotPostBody } from '@shared/api';
import { useNotify } from '@features/Notify';
import './AssignPositionDrawer.scss';
import { FaTicketAlt } from 'react-icons/fa';
import { postAssignBulkSecurity, postAssignSecurity } from '@widgets/AccountLevelPositionsTable/api';
import CloseSingleSecurityDrawerStore from '@widgets/OrderTable/store/account-refresh-store';
import snackbarStore from '@widgets/MainLayout/store/snackbar-store';
import { AssignBulkPositionForm } from './components/AssignPositionForm/AssignBulkPositionForm';

interface IAssignPositionDrawer {
    positionsRefresh: () => void;
    order?: any;
}

export const AssignPositionDrawer: React.FC<IAssignPositionDrawer> = ({ positionsRefresh, order }) => {
    const [loading, setLoading] = useState<boolean>(false);

    const setIsDrawerClosed = CloseSingleSecurityDrawerStore((state) => state.setIsDrawerClosed);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { setSnackbarMessage } = snackbarStore(); // Get the method to set the message
    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');

    const onSubmit = async (val: any) => {
        val.assignerId = userObject.accounts[0]?.id;
        if (order) {
            val.securityId = order?.securityId;
            val.averagePrice = order?.updatedPrice;
            val.orderId = order?.id;
        }

        setLoading(true);
        try {
            let response = '';
            if (order) {
                response = await postAssignSecurity(val);
            } else {
                response = await postAssignBulkSecurity(val);
            }
            if (response === 'Successfully Assigned Positions') {
                positionsRefresh();
                setIsDrawerClosed(true);
                setSnackbarMessage('Successfully Assigned Positions!');
            } else {
                setLoading(false);
                setErrorMessage(response);
            }
        } catch (error) {
            setErrorMessage('Error Assigning Positions: Please try again.');
            setSnackbarMessage('Error Assigning Positions. Please try again.');
        } finally {
            //setLoading(false); // Stop submitting
        }
    };

    return (
        <div className='widget-position-lot-add-drawer'>
            <DrawerHeader
                headerTitle={order ? `Assign Securities` : `Assign Bulk Securities`}
                headerIcon={<FaTicketAlt />}
            />
            {errorMessage && <div className='error-message-top'>{errorMessage}</div>}
            <Form<IServicePositionLotPostBody>
                onSubmit={onSubmit}
                render={(props: FormRenderProps<IServicePositionLotPostBody>) => {
                    return order ? (
                        <AssignPositionForm
                            {...props}
                            loading={loading}
                            order={order}
                        />
                    ) : (
                        <AssignBulkPositionForm
                            {...props}
                            loading={loading}
                            order={order}
                        />
                    );
                }}
            />
        </div>
    );
};
